<div class="container-xxl">
	<form>
		@if (partner) {
			<section>
				<div class="col-sm-12 text-center">
					<h1 class="header-title">
						<p>{{ partner.auctionName }}</p>
					</h1>
				</div>
				<div class="col-sm-12 text-center div-center">
					<img
						[src]="utils.getImageUrl(partner.largeLogo)"
						style="width: 900px; height: 200px"
					/>
					<span>
						<div class="partner-star">
							<star-rating
								[readOnly]="true"
								size="large"
								[rating]="partner.auctioneerRating ?? 0"
								staticColor="ok"
							></star-rating>
							<div class="voti">{{ partner.numFeedback }} {{ "privatePartner.votes" | translate }}</div>
						</div>
					</span>
					<br />
					<br />
					<br />
				</div>
				<div class="col-sm-12">
					<p class="notes text-center">
						{{ partner.description }}
					</p>
				</div>
				<div class="col-sm-12 text-center">
					<p class="notes"></p>
					<h4 class="title no-margin no-padding">
						<b>{{ "privatePartner.contacts" | translate }}:</b>
					</h4>
					<p class="notes">
						{{ "privatePartner.telephone" | translate }}:{{ partner.commercialInfoPhone }}
						<br />
						{{ "privatePartner.email" | translate }}:
						<a
							title=""
							class="link"
							href="{{ partner.commercialInfoEmail }}"
							target=""
						>
							{{ partner.commercialInfoEmail }}
						</a>
						<br />
						{{ "privatePartner.vatCode" | translate }}: {{ partner.vatCode }}
					</p>
				</div>
			</section>
		}

		<section class="nostri-espositori">
			<div
				class="item slider div-center text-center no-float"
				style="overflow: visible; margin-top: 20px"
			>
				<div class="content">
					<h3>{{ "privatePartner.ourPartners" | translate }}</h3>
					<owl-carousel-o [options]="customOptions">
						@for (p of partners; track p; let i = $index) {
							<ng-template carouselSlide>
								<a
									style="margin: 8px"
									(click)="selectedPartner(p)"
								>
									@if (p) {
										<img
											[src]="utils.getOpenImageUrl(p.smallLogo)"
											class="smallLogo"
										/>
									}
								</a>
							</ng-template>
						}
					</owl-carousel-o>
				</div>
			</div>
		</section>
	</form>
</div>